/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_variant_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does a longer test give a more accurate WPM?`)
};

const es_typing_variant_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Un test más largo da un WPM más preciso?`)
};

const de_typing_variant_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liefert ein längerer Test eine genauere WPM-Zahl?`)
};

const nl_typing_variant_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geeft een langere test een nauwkeurigere WPM?`)
};

const fr_typing_variant_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un test plus long donne-t-il un WPM plus précis ?`)
};

const it_typing_variant_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un test più lungo dà un WPM più accurato?`)
};

const pt_br2_typing_variant_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um teste mais longo dá um WPM mais preciso?`)
};

const pt_typing_variant_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um teste mais longo dá um WPM mais preciso?`)
};

const ja_typing_variant_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テスト時間が長いほどWPMは正確になりますか？`)
};

const zh_typing_variant_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更长的测试能得出更准确的WPM吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_variant_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_variant_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_variant_faq2_q", locale)
	if (locale === "en") return en_typing_variant_faq2_q(inputs)
	if (locale === "es") return es_typing_variant_faq2_q(inputs)
	if (locale === "de") return de_typing_variant_faq2_q(inputs)
	if (locale === "nl") return nl_typing_variant_faq2_q(inputs)
	if (locale === "fr") return fr_typing_variant_faq2_q(inputs)
	if (locale === "it") return it_typing_variant_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_typing_variant_faq2_q(inputs)
	if (locale === "pt") return pt_typing_variant_faq2_q(inputs)
	if (locale === "ja") return ja_typing_variant_faq2_q(inputs)
	return zh_typing_variant_faq2_q(inputs)
};